import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import moment from 'moment';

import {
  Button,
  NonEmptyArrayField,
  TextareaField,
  Label,
  DateField,
} from '../../common';

export default function SpecialOffers({
  value,
  errors,
  onChange,
  recipients,
  items,
}) {
  const { properties } = items;
  return (
    <NonEmptyArrayField
      value={value}
      defaultValue={{
        name: '',
        description: '',
        preferred: false,
      }}
      errors={errors}
      onChange={onChange}
      renderer={({ val, getHandler, del, add, idx, length, errors: errs }) => {
        return (
          <div key={idx} className="offer-methods">
            <div className="payment-billing-containers">
              <div className="title-header">
                <div className="label">
                  OFFER
                  {idx + 1}
                </div>
                <div>
                  {length > 0 && (
                    <Button
                      onClick={(e) => {
                        e.preventDefault();
                        del();
                      }}
                      style={{
                        padding: 0,
                        marginLeft: 5,
                        display: 'flex',
                        alignItems: 'center',
                        margin: 0,
                      }}
                    >
                      <i className="material-icons remove-icon">delete</i>
                      {' '}
                      Remove
                    </Button>
                  )}
                </div>
              </div>
              {properties?.patient_type && (
                <Select
                  placeholder="Patient Type"
                  name="patient_type"
                  classNamePrefix="react-select"
                  className="react-select-container"
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                  options={recipients}
                  value={recipients.filter(
                    (option) => option.value === val.patient_type,
                  )}
                  onChange={(obj) => {
                    if (obj) {
                      getHandler('patient_type')({ target: obj });
                    }
                  }}
                />
              )}
              <Label type="error">{errs.patient_type}</Label>
            </div>
            <div className="offer-data-container">
              <div className="date-range-container">
                {properties?.start_date && (
                  <div className="date-range-container__start">
                    <div className="label">
                      {properties?.start_date?.description || 'Start Date'}
                    </div>
                    <DateField
                      value={
                        val.start_date
                          ? val.start_date
                          : moment().format('YYYY-MM-DD')
                      }
                      onChange={getHandler('start_date')}
                      maxDate={
                        val.end_date
                          ? new Date(val.end_date)
                          : new Date('2100-12-31')
                      }
                      error={errs.start_date}
                      style={{
                        marginRight: 10,
                        width: 185,
                        verticalAlign: 'top',
                      }}
                    />
                  </div>
                )}
                {properties?.end_date && (
                  <div className="date-range-container__end">
                    <div className="label">
                      {properties?.end_date?.description || 'End Date'}
                    </div>
                    <DateField
                      value={
                        val.end_date
                          ? val.end_date
                          : moment().format('YYYY-MM-DD')
                      }
                      onChange={getHandler('end_date')}
                      minDate={
                        val.start_date ? new Date(val.start_date) : new Date()
                      }
                      maxDate={new Date('2100-12-31')}
                      error={errs.end_date}
                      style={{
                        width: 185,
                        verticalAlign: 'top',
                      }}
                    />
                  </div>
                )}
              </div>
              {properties?.description && (
                <div>
                  <div className="offer-data-container__label">
                    {properties?.description?.description || 'Description'}
                  </div>
                  <TextareaField
                    count
                    max={160}
                    placeholder="Add description here."
                    style={{ width: '100%' }}
                    value={val.description || ''}
                    onChange={getHandler('description')}
                  />
                </div>
              )}
              <Label type="error">{errs.description}</Label>
            </div>
            <div className="add-payment-button">
              {idx === length - 1 && (
                <Button
                  onClick={(e) => {
                    e.preventDefault();
                    add();
                  }}
                  style={{
                    padding: '20px',
                    marginLeft: 5,
                    display: 'flex',
                    alignItems: 'center',
                    margin: 0,
                  }}
                >
                  <i className="material-icons">add</i>
                  Add offer
                </Button>
              )}
            </div>
          </div>
        );
      }}
    />
  );
}

SpecialOffers.propTypes = {
  value: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.shape(), PropTypes.string]),
  ),
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.shape(),
  recipients: PropTypes.arrayOf(PropTypes.shape()),
};

SpecialOffers.defaultProps = {
  value: [],
  errors: {},
  recipients: [],
};
